<div class="browsing-controls" [class.active]="isActive" [dir]="direction.isRTL() ? 'rtl' : 'ltr'">
    <button type="button" class="nav-item" (click)="openMenu();">
        <div class="nav-icon">
            <mat-icon [inline]="true">{{mainIcon}}</mat-icon>
        </div>
    </button>

    <div class="controls" #browsingControls>
        <button type="button" class="btn" (click)="goBack();">
            <mat-icon [inline]="true">arrow_back</mat-icon>
        </button>
        <button type="button" class="btn" (click)="refresh();">
            <mat-icon [inline]="true">refresh</mat-icon>
        </button>
        <button type="button" class="btn" (click)="pageTop();">
            <mat-icon [inline]="true">arrow_upward</mat-icon>
        </button>
        <button type="button" class="btn" (click)="pageBottom();">
            <mat-icon [inline]="true">arrow_downward</mat-icon>
        </button>
        <app-chat-window *ngIf="siteService.features?.chat" [floatingButton]="false"></app-chat-window>
    </div>
</div>
